import React from 'react';
import FormWrapper from './FormWrapper';

const FormInput = function (props) {
  const { type, name, required } = props;
  const { text, value, ...rest } = props;

  return (
    <FormWrapper name={name} text={text} required={required} type={type}>
      <input id={props.name} value={value || ''} {...rest} onChange={() => { /* let event bubble */ }} />
    </FormWrapper>
  );
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormInput.js